export default __webpack_public_path__ + "static/SR China - AIB-GMP 2022 - Certificate-b7033c91a6d7e38e23f4a1d5a435a9ad.pdf";